<script lang="ts">
  import { onDestroy } from 'svelte'
  import Search from '@lucide/svelte/icons/search'
  import X from '@lucide/svelte/icons/x'
  import Loader2 from '@lucide/svelte/icons/loader-2'
  import { createGlobalSearch } from '@/utils/globalSearch.svelte'
  import GlobalSearchResults from './GlobalSearchResults.svelte'

  let {
    applicationId,
    indexName,
  }: {
    applicationId: string
    indexName: string
  } = $props()

  const search = createGlobalSearch({
    applicationId: () => applicationId,
    indexName: () => indexName,
  })

  onDestroy(() => search.destroy())
</script>

<button
  type="button"
  onclick={() => search.open()}
  class="flex items-center gap-1 p-2 text-sm font-medium text-neutral-600 dark:text-gray-300 hover:text-neutral-900 dark:hover:text-white hover:bg-neutral-200 dark:hover:bg-gray-700 rounded-md transition"
  aria-label="Search"
>
  <Search size={20} />
</button>

{#if search.showSearch}
  <div class="md:hidden fixed inset-0 bg-neutral-50 dark:bg-gray-900 z-50">
    <div class="flex flex-col h-full">
      <div
        class="flex items-center gap-3 p-4 border-b border-gray-200 dark:border-gray-700"
      >
        <button
          type="button"
          onclick={() => search.close()}
          class="p-2 text-neutral-600 dark:text-gray-300 hover:text-neutral-900 dark:hover:text-white"
          aria-label="Close search"
        >
          <X size={24} />
        </button>
        <!-- svelte-ignore a11y_autofocus -->
        <input
          type="text"
          bind:value={search.query}
          oninput={() => search.handleInput()}
          placeholder="Search..."
          class="flex-1 px-4 py-2 bg-gray-100 dark:bg-gray-800 border-0 rounded-full text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
          autofocus
        />
      </div>

      <div class="flex-1 overflow-y-auto">
        {#if search.isSearching}
          <div class="flex items-center justify-center gap-2 p-8">
            <Loader2
              size={20}
              class="text-primary-600 dark:text-primary-400 animate-spin"
            />
            <span class="text-gray-500 dark:text-gray-400">Searching...</span>
          </div>
        {:else if search.mergedResults.length > 0 || search.isSearchingBooks || search.bookSearchError}
          <div class="divide-y divide-gray-100 dark:divide-gray-800">
            <GlobalSearchResults
              items={search.mergedResults}
              layout="mobile"
              isSearchingBooks={search.isSearchingBooks}
              error={search.bookSearchError}
              onSelectHit={(hit) => search.selectResult(hit)}
              onSelectExternal={(book) => search.selectExternal(book)}
            />
          </div>
        {:else if search.hasNoResults}
          <div class="flex items-center justify-center p-8">
            <span class="text-gray-500 dark:text-gray-400"
              >No catalog or Google Books results for "{search.query}". Try a
              title, author, series, or genre.</span
            >
          </div>
        {:else if search.query.length > 0}
          <div class="flex items-center justify-center p-8">
            <span class="text-gray-500 dark:text-gray-400"
              >Type at least 2 characters to search</span
            >
          </div>
        {:else}
          <div class="flex items-center justify-center p-8">
            <span class="text-gray-500 dark:text-gray-400"
              >Search for books, authors, series, or users. Books not yet in our
              catalog show up from Google Books — tap one to add it.
            </span>
          </div>
        {/if}
      </div>
    </div>
  </div>
{/if}
